// Ordinary LifeObjects historically include an empty chatbot placeholder.
// Presence of that object alone is not evidence of a configured LifeBot.
export const isLifeBot = (object) => {
  const bot = object?.chatbot;
  return Boolean(
    bot &&
      typeof bot === 'object' &&
      !Array.isArray(bot) &&
      ((typeof bot.chatBotId === 'string' && bot.chatBotId.trim()) ||
        ['processing', 'ready', 'failed'].includes(bot.status))
  );
};
